import React, { useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import { get, post } from '../../utils/apiManager';
import { baseURL } from '../../config/config';
import { toast } from 'react-toastify';

const StripeSettings = () => {
    const {
        register,
        handleSubmit,
        setValue,
        reset,
        formState: { errors },
    } = useForm();

    const [message, setMessage] = React.useState('');
    const [showPassword, setShowPassword] = useState(false);

    const togglePassword = () => {
        setShowPassword(prev => !prev);
    };

    // Fetch existing keys on load
    useEffect(() => {
        get(`/payment-setting`).then((res) => {
            if (res?.datas) {
                setValue('publicKey', res.datas.publicKey || '');
                setValue('secretKey', res.datas.secretKey || '');
                setValue('id', res.datas._id || '');
            }

        }).catch((error) => {
            console.log(error, "erre");
        })

    }, [setValue]);

    // Handle form submit 
    const onSubmit = async (data) => {
        const Url = `${baseURL}/payment-setting/update`
        post(Url, { secretKey: data?.secretKey, publicKey: data?.publicKey, id: data?.id }).then((data) => {
            if (data?.status) {
                toast.success(data?.message);
            }
            else {
                toast.error(data?.message)
            }
        }).catch(err => {
            toast.error(err.response.data.error || err.response.data.message || "Something went wrong");
        })
    };

    return (
        <div className="container mt-10" style={{ marginTop: '100px' }}>
            <div className="card shadow-sm">
                <div className="card-body">
                    <h3 className="card-title mb-4">Stripe API Settings</h3>

                    <form onSubmit={handleSubmit(onSubmit)}>
                        <div className='col-md-12 '>
                            <div className="mb-3 col-md-6">
                                <label className="form-label">Public Key</label>
                                <input
                                    type="text"
                                    className={`form-control ${errors.publicKey ? 'is-invalid' : ''}`}
                                    {...register('publicKey', { required: 'Public key is required' })}
                                />
                                {errors.publicKey && (
                                    <div className="invalid-feedback">{errors.publicKey.message}</div>
                                )}
                            </div>

                            <div className="mb-3 col-md-6">
                                <label className="form-label">Secret Key</label>
                                <div className="input-group">
                                    <input
                                        type={showPassword ? 'text' : 'password'}
                                        className={`form-control ${errors.secretKey ? 'is-invalid' : ''}`}
                                        {...register('secretKey', { required: 'Secret key is required' })}
                                    />
                                    <button
                                        type="button"
                                        className="btn btn-outline-secondary"
                                        onClick={togglePassword}
                                        tabIndex={-1}
                                    >
                                        <i style={{color: "black"}} className={`bi ${showPassword ? 'bi-eye-slash' : 'bi-eye'}`}></i>
                                    </button>
                                </div> 
                                {errors.secretKey && (
                                    <div className="invalid-feedback d-block">{errors.secretKey.message}</div>
                                )}
                            </div>  
                             
                        </div>

                        <button type="submit" className="btn btn-primary  ">
                            Save Keys
                        </button>
                    </form>

                    {message && <div className="alert alert-info mt-3">{message}</div>}
                </div>
            </div>
        </div>
    );
};

export default StripeSettings;
